import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../features/productDetail/components/Breadcrumb";
import ProductDescription from "../features/productDetail/components/ProductDescription";
import ProductImage from "../features/productDetail/components/ProductImage";
import SimilarProducts from "../features/productDetail/components/SimilarProducts";

interface Category {
  id: number;
  name: string;
  slug: string;
}

interface ProductData {
  id: number;
  name: string;
  images: { src: string }[];
  description: string;
  attributes: { name: string; options: string[] }[];
  categories: Category[]; // добавляем категории
}

const Product: React.FC = () => {
  const { productId } = useParams();
  const [product, setProduct] = useState<ProductData | null>(null);

  const API_URL = "https://huter.diy/wordpress/wp-json/wc/v3/products";
  const API_KEY = 'ck_b633c1877cf1de3bdbb01117e1fa8215b9b99e43';
  const API_SECRET = 'cs_5c69080f905a13fda5aefffb41f6ac3988ab6478';

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const response = await fetch(
          `${API_URL}/${productId}?consumer_key=${API_KEY}&consumer_secret=${API_SECRET}`
        );
        const data: ProductData = await response.json();
        setProduct(data);
      } catch (error) {
        console.error("Ошибка загрузки товара:", error);
      }
    };

    if (productId) {
      fetchProduct();
    }


    window.scrollTo(0, 0);
  }, [productId]);

  if (!product) {
    return <div className="text-center text-xl font-bold">Loading...</div>;
  }

  const category = product.categories.length > 0 ? product.categories[0] : { name: "Каталог", slug: "catalog" };

  return (
    <div className="px-0 py-[60px] mx-auto my-0 max-w-[1290px]">
      <Breadcrumb category={category} productName={product.name} />
      <h1 className="mb-8 text-4xl font-bold max-sm:text-3xl">{product.name}</h1>
      <ProductImage images={product.images} />
      <ProductDescription description={product.description} attributes={product.attributes} />
      <SimilarProducts currentProductId={product.id} />
    </div>
  );
};

export default Product;
